import { Component, inject, input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { LoginDto } from '@core/dtos/auth';
import { AuthService } from '@core/services/auth.service';
import { SplashScreenService } from '@core/services/splash-screen.service';
import { jwtCredentials } from '@core/signals/auth.signal';
import { CommonValidators } from '@core/validators/common.validators';
import { MatErrorMessagesComponent } from '@shared/components/dumb/mat-error-messages/mat-error-messages.component';
import { PasswordTogglerComponent } from '@shared/components/dumb/password-toggler/password-toggler.component';
import { PromiseButtonDirective } from '@shared/directives/attribute/promise-button.directive';
import { TrimInputDirective } from '@shared/directives/attribute/trim-input.directive';
import { ValidSubmitDirective } from '@shared/directives/attribute/valid-submit.directive';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  imports: [
    FormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatErrorMessagesComponent,
    MatFormFieldModule,
    MatInputModule,
    PasswordTogglerComponent,
    PromiseButtonDirective,
    ReactiveFormsModule,
    ValidSubmitDirective,
    TrimInputDirective,
  ],

  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  authService = inject(AuthService);
  router = inject(Router);
  loginForm: FormGroup;
  subscription!: Subscription;
  splashScreenService = inject(SplashScreenService);
  returnUrl = input<string>();

  constructor() {
    const { required, email } = CommonValidators;
    this.loginForm = new FormGroup({
      email: new FormControl('', [required, email]),
      password: new FormControl('', [required]),
      rememberMe: new FormControl(false),
    });
    this.splashScreenService.hide();
  }

  ngOnInit(): void {
    const credentials = this.authService.restoreCredentials();
    if (credentials) this.loginForm.patchValue(credentials);
  }

  login() {
    this.subscription = this.authService.login(this.loginForm.value as LoginDto).subscribe((_) => {
      if (jwtCredentials()?.accessToken) {
        this.router.navigateByUrl(this.returnUrl() ?? '/');
      }
    });
  }
}
